import React, { useState, useRef, useEffect } from 'react';
import ArrowDownIcon from '../svg/ArrowDownIcon'

interface DropdownMenuProps {
  label: string;
  actions: { label: string, classes: string, onClick: () => void }[];
  className?: string;
  menuPosition?: 'top' | 'bottom';
  arrowColor?: string;
  mainActionClick: () => void;
}

const ButtonDropdown: React.FC<DropdownMenuProps> = ({ label, actions, className, menuPosition = 'bottom', arrowColor, mainActionClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleItemClick = (action: () => void) => {
    action();
    setIsOpen(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown-menu-container custom-dropdown-container" ref={menuRef}>
      <button 
        onClick={() => mainActionClick()}
        className={`dropdown-button-action ${className ?? ''}`} 
      >
        {label}
      </button>

      <button 
        onClick={toggleMenu} 
        className={`dropdown-button-toggle ${className ?? ''} button--medium-dropdown`} 
        aria-expanded={isOpen}
      >
        <span className={`dropdown-icon ${isOpen ? 'open' : ''}`}><ArrowDownIcon color={arrowColor} /></span>
      </button>

      {isOpen && (
        <ul className={`dropdown-menu ${menuPosition}`}>
          {actions.map((action, index) => (
            <li key={index}>
              <button className={action.classes} onClick={() => handleItemClick(action.onClick)}>
                {action.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ButtonDropdown;